import { post as postAPICall } from 'aws-amplify/api';
import { errorHandler } from 'utils/Api';

export const reportWarehousePrealert = async (packageData) => {
    try {
        const postPayload = {
            apiName: "unboxing",
            path: "/reportWarehousePrealert",
            options: {
                body: packageData
            }

        };
        const restOperation = await postAPICall(postPayload).response;
        const response = await restOperation.body.json();

        if (response.data != "success") {
            errorHandler(postPayload, `Error al enviar el reporte de prealert al warehouse`);
        }
    } catch (err) {
        errorHandler(packageData, `Error al enviar el reporte de prealert al warehouse`);
    }
}

export const deleteWarehousePrealert = async (packageData) => {
    try {
        const postPayload = {
            apiName: "unboxing",
            path: "/deleteWarehousePrealert",
            options: {
                body: packageData
            }

        };
        const restOperation = await postAPICall(postPayload).response;
        const response = await restOperation.body.json();

        if (response.data != "success") {
            errorHandler(postPayload, `Error al enviar el reporte de prealert al warehouse`);
        }
    } catch (err) {
        errorHandler(packageData, `Error al enviar el reporte de prealert al warehouse`);
    }
}